export function initScrollBulkActionsIntoView() {
    const TARGET_ATTR = 'data-bulk-actions-frame';
    const lastCountByGrid = new Map();
    const savedScrollByGrid = new Map();

    function isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function findTarget(gridId) {
        const targets = document.querySelectorAll('[' + TARGET_ATTR + ']');
        for (const target of targets) {
            const forGrid = target.getAttribute(TARGET_ATTR);
            if (forGrid && forGrid !== gridId) continue;
            if (isVisible(target)) return target;
        }
        return null;
    }

    function isScrollable(el) {
        const style = getComputedStyle(el);
        const overflowY = style.overflowY;
        return (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
    }

    function getScrollParents(el) {
        const parents = [];
        let node = el.parentElement;
        while (node) {
            if (isScrollable(node)) parents.push(node);
            node = node.parentElement;
        }
        parents.push(document.scrollingElement || document.documentElement);
        return parents;
    }

    function pulse(target) {
        target.classList.remove('bulk-actions-pulse');
        void target.offsetWidth;
        target.classList.add('bulk-actions-pulse');
        target.addEventListener('animationend', () => target.classList.remove('bulk-actions-pulse'), { once: true });
    }

    document.addEventListener('data-grid-selection-change', (e) => {
        const detail = e.detail || {};
        const gridId = detail.gridId || '';
        const count = detail.checkedCount || 0;
        const previous = lastCountByGrid.get(gridId) || 0;
        lastCountByGrid.set(gridId, count);

        if (previous === 0 && count > 0) {
            const target = findTarget(gridId);
            if (!target) return;
            const containers = getScrollParents(target).map((el) => ({ el, top: el.scrollTop, left: el.scrollLeft }));
            savedScrollByGrid.set(gridId, containers);
            const innerScroller = containers.length > 1 ? containers[0].el : null;
            if (innerScroller) {
                innerScroller.scrollTo({ top: innerScroller.scrollHeight, behavior: 'smooth' });
            } else {
                target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            pulse(target);
        } else if (previous > 0 && count === 0) {
            const containers = savedScrollByGrid.get(gridId);
            if (!containers) return;
            containers.forEach(({ el, top, left }) => el.scrollTo({ top, left, behavior: 'smooth' }));
            savedScrollByGrid.delete(gridId);
        }
    });
}
